import { registerSprite } from "./registry";

const C = {
  void:     "#05060a",
  panel:    "#2f3648",
  panelHi:  "#3c4458",
  rim:      "#4b5468",
  hull:     "#6e7388",
  hullHi:   "#8a8e9e",
  armor:    "#a7aabb",
  trim:     "#c8c4b4",
  trimHi:   "#e6e2cf",
  cockpit:  "#3a5b7a",
  cockHi:   "#5f8db6",
  gun:      "#8a3f2a",
  gunHot:   "#c0552f",
  fission:  "#3a8a55",
  rtg:      "#6e5a26",
  rtgHot:   "#d4a23b",
  carbon:   "#2c2c2c",
  thruster: "#5b6b8a",
  nozzle:   "#a4b3c9",
  ion:      "#26506b",
  ionHot:   "#4c93b8",
  ember:    "#d36b3c",
  brass:    "#b3a06b",
  olive:    "#4e6e3a",
  warn:     "#9b2d2d",
};

function svg(viewW: number, viewH: number, body: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${viewW} ${viewH}" shape-rendering="crispEdges">${body}</svg>`;
}

registerSprite("hull_plate_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect width="8" height="1" fill="${C.hullHi}"/>
    <rect y="7" width="8" height="1" fill="${C.rim}"/>
    <rect x="1" y="1" width="1" height="1" fill="${C.panelHi}"/>
    <rect x="6" y="1" width="1" height="1" fill="${C.panelHi}"/>
    <rect x="1" y="6" width="1" height="1" fill="${C.panelHi}"/>
    <rect x="6" y="6" width="1" height="1" fill="${C.panelHi}"/>
  `),
});

// The polygon (not a rect) gives the alpha mask its triangular shape so
// the collision-shape decomposer derives a triangular hitbox.
registerSprite("hull_triangle_1x1", {
  width: 8, height: 8,
  svg: svg(8, 8, `<polygon points="0,0 0,8 8,8" fill="${C.hull}"/>`),
});

registerSprite("hull_triangle_1x1_mirror", {
  width: 8, height: 8,
  svg: svg(8, 8, `<polygon points="8,0 8,8 0,8" fill="${C.hull}"/>`),
});

registerSprite("hull_wedge_2x1", {
  width: 16, height: 8,
  svg: svg(16, 8, `<polygon points="0,0 0,8 16,8" fill="${C.hull}"/>`),
});

registerSprite("hull_wedge_2x1_mirror", {
  width: 16, height: 8,
  svg: svg(16, 8, `<polygon points="16,0 16,8 0,8" fill="${C.hull}"/>`),
});

const TRUSS_COLOR = "#2a2d36";
const TRUSS_STROKE = 0.6;
/** Outline sits on the cell edge, so its outer half is clipped by the
 *  viewBox; ×4 (= 2× visible thickness of the inner bars) makes the
 *  frame read as a heavier border around the lattice. */
const TRUSS_OUTLINE_STROKE = TRUSS_STROKE * 4;

function trussSvg(viewW: number, viewH: number, body: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${viewW} ${viewH}" shape-rendering="crispEdges">` +
    `<g fill="none" stroke="${TRUSS_COLOR}" stroke-width="${TRUSS_STROKE}" ` +
    `stroke-linecap="butt" stroke-linejoin="miter">${body}</g></svg>`;
}

registerSprite("truss_square_1x1", {
  width: 8, height: 8,
  svg: trussSvg(8, 8, `
    <rect x="0" y="0" width="8" height="8" stroke-width="${TRUSS_OUTLINE_STROKE}"/>
    <line x1="0" y1="0" x2="8" y2="8"/>
    <line x1="8" y1="0" x2="0" y2="8"/>
  `),
});

registerSprite("truss_triangle_1x1", {
  width: 8, height: 8,
  svg: trussSvg(8, 8, `
    <polygon points="0,0 0,8 8,8" stroke-width="${TRUSS_OUTLINE_STROKE}"/>
    <line x1="0" y1="8" x2="4" y2="4"/>
  `),
});

registerSprite("truss_triangle_1x1_mirror", {
  width: 8, height: 8,
  svg: trussSvg(8, 8, `
    <polygon points="8,0 8,8 0,8" stroke-width="${TRUSS_OUTLINE_STROKE}"/>
    <line x1="8" y1="8" x2="4" y2="4"/>
  `),
});

registerSprite("truss_beam_2x1", {
  width: 16, height: 8,
  svg: trussSvg(16, 8, `
    <rect x="0" y="2" width="16" height="4" stroke-width="${TRUSS_OUTLINE_STROKE}"/>
    <line x1="8"  y1="2" x2="8"  y2="6"/>
    <line x1="0"  y1="2" x2="8"  y2="6"/>
    <line x1="8"  y1="2" x2="0"  y2="6"/>
    <line x1="8"  y1="2" x2="16" y2="6"/>
    <line x1="16" y1="2" x2="8"  y2="6"/>
  `),
});

registerSprite("longeron_2x1", {
  width: 16, height: 8,
  svg: svg(16, 8, `
    <rect x="1"  y="3" width="14" height="2" fill="${C.hull}"/>
    <rect x="1"  y="3" width="14" height="1" fill="${C.hullHi}"/>
    <rect x="0"  y="2" width="2"  height="4" fill="${C.rim}"/>
    <rect x="14" y="2" width="2"  height="4" fill="${C.rim}"/>
    <rect x="0"  y="3" width="1"  height="1" fill="${C.trim}"/>
    <rect x="15" y="3" width="1"  height="1" fill="${C.trim}"/>
  `),
});

registerSprite("insulator_beam_2x1", {
  width: 16, height: 8,
  svg: svg(16, 8, `
    <rect x="1"  y="2" width="14" height="4" fill="#5e5644"/>
    <rect x="1"  y="2" width="14" height="1" fill="#48422f"/>
    <rect x="1"  y="5" width="14" height="1" fill="#2e2a1c"/>
    <rect x="3"  y="2" width="1"  height="4" fill="${C.brass}"/>
    <rect x="8"  y="2" width="1"  height="4" fill="${C.brass}"/>
    <rect x="12" y="2" width="1"  height="4" fill="${C.brass}"/>
    <rect x="0"  y="2" width="2"  height="4" fill="${C.rim}"/>
    <rect x="14" y="2" width="2"  height="4" fill="${C.rim}"/>
    <rect x="0"  y="3" width="1"  height="1" fill="${C.trim}"/>
    <rect x="15" y="3" width="1"  height="1" fill="${C.trim}"/>
  `),
});

registerSprite("conductivity_beam_2x1", {
  width: 16, height: 8,
  svg: svg(16, 8, `
    <rect x="1"  y="2" width="14" height="4" fill="#e88080"/>
    <rect x="1"  y="2" width="14" height="1" fill="#b86060"/>
    <rect x="1"  y="5" width="14" height="1" fill="#8a4040"/>
    <rect x="3"  y="2" width="1"  height="4" fill="${C.brass}"/>
    <rect x="8"  y="2" width="1"  height="4" fill="${C.brass}"/>
    <rect x="12" y="2" width="1"  height="4" fill="${C.brass}"/>
    <rect x="0"  y="2" width="2"  height="4" fill="${C.rim}"/>
    <rect x="14" y="2" width="2"  height="4" fill="${C.rim}"/>
    <rect x="0"  y="3" width="1"  height="1" fill="${C.trim}"/>
    <rect x="15" y="3" width="1"  height="1" fill="${C.trim}"/>
  `),
});

registerSprite("conductivity_node_1x1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect x="1" y="1" width="6" height="6" fill="#e88080"/>
    <rect x="2" y="2" width="4" height="4" fill="#b86060"/>
    <rect x="3" y="3" width="2" height="2" fill="${C.brass}"/>
    <rect x="0" y="2" width="1" height="4" fill="${C.rim}"/>
    <rect x="7" y="2" width="1" height="4" fill="${C.rim}"/>
    <rect x="2" y="0" width="4" height="1" fill="${C.rim}"/>
    <rect x="2" y="7" width="4" height="1" fill="${C.rim}"/>
    <rect x="0" y="3" width="1" height="2" fill="${C.trim}"/>
    <rect x="7" y="3" width="1" height="2" fill="${C.trim}"/>
    <rect x="3" y="0" width="2" height="1" fill="${C.trim}"/>
    <rect x="3" y="7" width="2" height="1" fill="${C.trim}"/>
  `),
});

registerSprite("armor_plate_mk2", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.armor}"/>
    <rect y="0" width="8" height="1" fill="${C.trim}"/>
    <rect y="7" width="8" height="1" fill="${C.rim}"/>
    <path d="M1 1 H7 V7 H1 Z" fill="${C.hullHi}"/>
    <path d="M2 2 H6 V6 H2 Z" fill="${C.armor}"/>
  `),
});

registerSprite("insulation_plate_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="#5e5644"/>
    <rect x="1" y="1" width="6" height="6" fill="#48422f"/>
    <rect x="2" y="2" width="4" height="4" fill="#2e2a1c"/>
    <rect x="3" y="3" width="2" height="2" fill="${C.brass}"/>
    <rect x="0" y="3" width="1" height="2" fill="${C.brass}"/>
    <rect x="7" y="3" width="1" height="2" fill="${C.brass}"/>
    <rect x="3" y="0" width="2" height="1" fill="${C.brass}"/>
    <rect x="3" y="7" width="2" height="1" fill="${C.brass}"/>
  `),
});

registerSprite("cockpit_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="2" y="1" width="4" height="6" fill="${C.cockpit}"/>
    <rect x="3" y="2" width="2" height="4" fill="${C.cockHi}"/>
    <rect x="0" y="3" width="1" height="2" fill="${C.trimHi}"/>
    <rect x="7" y="3" width="1" height="2" fill="${C.trimHi}"/>
  `),
});

registerSprite("rtg_small", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.rtg}"/>
    <rect x="1" y="1" width="6" height="6" fill="${C.carbon}"/>
    <rect x="3" y="3" width="2" height="2" fill="${C.rtgHot}"/>
    <rect x="0" y="3" width="1" height="2" fill="${C.rtgHot}"/>
    <rect x="7" y="3" width="1" height="2" fill="${C.rtgHot}"/>
    <rect x="3" y="0" width="2" height="1" fill="${C.rtgHot}"/>
    <rect x="3" y="7" width="2" height="1" fill="${C.rtgHot}"/>
  `),
});

registerSprite("fission_mk1", {
  width: 16, height: 16,
  svg: svg(16, 16, `
    <rect width="16" height="16" fill="${C.panel}"/>
    <rect x="1" y="1" width="14" height="14" fill="${C.rim}"/>
    <circle cx="8" cy="8" r="5" fill="${C.fission}"/>
    <circle cx="8" cy="8" r="3" fill="${C.trimHi}"/>
    <circle cx="8" cy="8" r="1" fill="${C.fission}"/>
    <rect x="0" y="7" width="2" height="2" fill="${C.trimHi}"/>
    <rect x="14" y="7" width="2" height="2" fill="${C.trimHi}"/>
    <rect x="7" y="0" width="2" height="2" fill="${C.trimHi}"/>
    <rect x="7" y="14" width="2" height="2" fill="${C.trimHi}"/>
  `),
});

registerSprite("fuel_tank_mk1", {
  width: 16, height: 8,
  svg: svg(16, 8, `
    <rect width="16" height="8" fill="${C.panel}"/>
    <rect x="1" y="1" width="14" height="6" fill="${C.hull}"/>
    <rect x="1" y="2" width="14" height="4" fill="${C.hullHi}"/>
    <rect x="0"  y="3" width="1" height="2" fill="${C.rim}"/>
    <rect x="15" y="3" width="1" height="2" fill="${C.rim}"/>
    <rect x="2"  y="3" width="2" height="2" fill="${C.gunHot}"/>
    <rect x="12" y="3" width="2" height="2" fill="${C.gunHot}"/>
    <rect x="6"  y="3" width="4" height="2" fill="${C.brass}"/>
  `),
});

registerSprite("battery_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.panel}"/>
    <rect x="1" y="1" width="6" height="6" fill="${C.carbon}"/>
    <rect x="2" y="2" width="1" height="4" fill="${C.olive}"/>
    <rect x="4" y="2" width="1" height="4" fill="${C.olive}"/>
    <rect x="6" y="2" width="1" height="4" fill="${C.olive}"/>
  `),
});

registerSprite("thruster_chem_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.thruster}"/>
    <rect x="0" y="2" width="3" height="4" fill="${C.carbon}"/>
    <rect x="0" y="3" width="2" height="2" fill="${C.gunHot}"/>
    <rect x="3" y="1" width="5" height="6" fill="${C.nozzle}"/>
    <rect x="6" y="3" width="2" height="2" fill="${C.rim}"/>
  `),
});

registerSprite("rcs_quad", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.panel}"/>
    <rect x="3" y="0" width="2" height="2" fill="${C.nozzle}"/>
    <rect x="3" y="6" width="2" height="2" fill="${C.nozzle}"/>
    <rect x="0" y="3" width="2" height="2" fill="${C.nozzle}"/>
    <rect x="6" y="3" width="2" height="2" fill="${C.nozzle}"/>
    <rect x="3" y="3" width="2" height="2" fill="${C.carbon}"/>
  `),
});

registerSprite("pdc_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="1" y="3" width="4" height="2" fill="${C.carbon}"/>
    <rect x="5" y="3" width="3" height="2" fill="${C.gun}"/>
    <rect x="7" y="3" width="1" height="2" fill="${C.gunHot}"/>
    <rect x="2" y="1" width="3" height="1" fill="${C.rim}"/>
    <rect x="2" y="6" width="3" height="1" fill="${C.rim}"/>
  `),
});

registerSprite("auto_cannon_mk1", {
  width: 16, height: 8,
  svg: svg(16, 8, `
    <rect width="16" height="8" fill="${C.hullHi}"/>
    <rect x="1"  y="2" width="14" height="4" fill="${C.carbon}"/>
    <rect x="2"  y="3" width="12" height="2" fill="${C.gun}"/>
    <rect x="14" y="3" width="2"  height="2" fill="${C.gunHot}"/>
    <rect x="7"  y="1" width="2"  height="6" fill="${C.rim}"/>
  `),
});

registerSprite("rail_mk1", {
  width: 24, height: 8,
  svg: svg(24, 8, `
    <rect width="24" height="8" fill="${C.panel}"/>
    <rect x="0"  y="0" width="4"  height="8" fill="${C.rim}"/>
    <rect x="4"  y="2" width="20" height="4" fill="${C.carbon}"/>
    <rect x="4"  y="3" width="20" height="2" fill="${C.cockHi}"/>
    <rect x="13" y="1" width="1"  height="6" fill="${C.trimHi}"/>
  `),
});

registerSprite("mining_laser_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="1" y="2" width="3" height="4" fill="${C.carbon}"/>
    <rect x="4" y="3" width="3" height="2" fill="${C.ion}"/>
    <rect x="7" y="3" width="1" height="2" fill="${C.ionHot}"/>
    <rect x="2" y="3" width="1" height="2" fill="${C.cockHi}"/>
    <rect x="2" y="0" width="3" height="1" fill="${C.rim}"/>
    <rect x="2" y="7" width="3" height="1" fill="${C.rim}"/>
  `),
});

registerSprite("missile_rack_mk1", {
  width: 16, height: 8,
  svg: svg(16, 8, `
    <rect width="16" height="8" fill="${C.panel}"/>
    <rect x="2" y="2" width="3" height="4" fill="${C.gun}"/>
    <rect x="6" y="2" width="3" height="4" fill="${C.gun}"/>
    <rect x="10" y="2" width="3" height="4" fill="${C.gun}"/>
    <rect x="5" y="3" width="1" height="2" fill="${C.gunHot}"/>
    <rect x="9" y="3" width="1" height="2" fill="${C.gunHot}"/>
    <rect x="13" y="3" width="1" height="2" fill="${C.gunHot}"/>
  `),
});

registerSprite("radar_passive_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.panel}"/>
    <rect x="3" y="0" width="2" height="3" fill="${C.rim}"/>
    <rect x="2" y="3" width="4" height="1" fill="${C.trim}"/>
    <rect x="1" y="4" width="6" height="1" fill="${C.trim}"/>
    <rect x="0" y="5" width="8" height="1" fill="${C.trim}"/>
  `),
});

registerSprite("radar_active_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.panel}"/>
    <rect x="3" y="0" width="2" height="2" fill="${C.warn}"/>
    <rect x="2" y="2" width="4" height="1" fill="${C.trim}"/>
    <rect x="1" y="3" width="6" height="1" fill="${C.trimHi}"/>
    <rect x="0" y="4" width="8" height="1" fill="${C.trimHi}"/>
    <rect x="1" y="5" width="6" height="2" fill="${C.cockHi}"/>
  `),
});

registerSprite("radiator_mk1", {
  width: 8, height: 16,
  svg: svg(8, 16, `
    <rect width="8" height="16" fill="${C.panel}"/>
    <rect x="3" y="1" width="2" height="14" fill="${C.rim}"/>
    <rect x="0" y="3" width="8" height="1" fill="${C.gunHot}"/>
    <rect x="0" y="7" width="8" height="1" fill="${C.gunHot}"/>
    <rect x="0" y="11" width="8" height="1" fill="${C.gunHot}"/>
  `),
});

registerSprite("cargo_bay_mk1", {
  width: 16, height: 16,
  svg: svg(16, 16, `
    <rect width="16" height="16" fill="${C.hull}"/>
    <rect x="1" y="1" width="14" height="14" fill="${C.rim}"/>
    <rect x="3" y="3" width="4" height="4" fill="${C.brass}"/>
    <rect x="9" y="3" width="4" height="4" fill="${C.brass}"/>
    <rect x="3" y="9" width="4" height="4" fill="${C.brass}"/>
    <rect x="9" y="9" width="4" height="4" fill="${C.brass}"/>
  `),
});

registerSprite("rock_block", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="#4b4f5a"/>
    <rect x="1" y="1" width="2" height="2" fill="#6a6e7a"/>
    <rect x="4" y="3" width="2" height="2" fill="#6a6e7a"/>
    <rect x="2" y="5" width="2" height="1" fill="#3a3a44"/>
    <rect x="5" y="1" width="1" height="1" fill="#6a6e7a"/>
    <rect x="6" y="5" width="1" height="2" fill="#3a3a44"/>
  `),
});

registerSprite("iron_ore_block", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="#4b4f5a"/>
    <rect x="1" y="2" width="3" height="2" fill="#7a5a3a"/>
    <rect x="2" y="3" width="2" height="1" fill="#b3865a"/>
    <rect x="5" y="4" width="2" height="2" fill="#7a5a3a"/>
    <rect x="6" y="5" width="1" height="1" fill="#b3865a"/>
    <rect x="3" y="6" width="1" height="1" fill="#7a5a3a"/>
  `),
});

registerSprite("copper_ore_block", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="#4b4f5a"/>
    <rect x="1" y="3" width="2" height="2" fill="#7e3f1f"/>
    <rect x="2" y="4" width="1" height="1" fill="#d36b3c"/>
    <rect x="4" y="1" width="2" height="2" fill="#7e3f1f"/>
    <rect x="5" y="2" width="1" height="1" fill="#d36b3c"/>
    <rect x="5" y="5" width="2" height="2" fill="#7e3f1f"/>
    <rect x="6" y="6" width="1" height="1" fill="#d36b3c"/>
  `),
});

registerSprite("uranium_ore_block", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="#4b4f5a"/>
    <rect x="2" y="2" width="2" height="2" fill="#3a8a55"/>
    <rect x="3" y="3" width="1" height="1" fill="#a4d99a"/>
    <rect x="4" y="5" width="2" height="2" fill="#3a8a55"/>
    <rect x="5" y="6" width="1" height="1" fill="#a4d99a"/>
    <rect x="1" y="5" width="1" height="1" fill="#3a8a55"/>
  `),
});

registerSprite("ice_block", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="#8aaecd"/>
    <rect x="1" y="2" width="2" height="1" fill="#d6e8f4"/>
    <rect x="4" y="3" width="3" height="1" fill="#d6e8f4"/>
    <rect x="2" y="5" width="2" height="1" fill="#d6e8f4"/>
    <rect x="5" y="6" width="2" height="1" fill="#d6e8f4"/>
  `),
});

registerSprite("rock_damage", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect x="2" y="0" width="1" height="3" fill="#000" fill-opacity="0.78"/>
    <rect x="3" y="2" width="1" height="2" fill="#000" fill-opacity="0.7"/>
    <rect x="3" y="4" width="2" height="1" fill="#000" fill-opacity="0.78"/>
    <rect x="5" y="5" width="1" height="2" fill="#000" fill-opacity="0.7"/>
    <rect x="0" y="3" width="2" height="1" fill="#000" fill-opacity="0.55"/>
    <rect x="6" y="1" width="2" height="1" fill="#000" fill-opacity="0.55"/>
    <rect x="0" y="0" width="1" height="1" fill="#000" fill-opacity="0.5"/>
    <rect x="7" y="0" width="1" height="1" fill="#000" fill-opacity="0.5"/>
    <rect x="0" y="7" width="1" height="1" fill="#000" fill-opacity="0.5"/>
    <rect x="7" y="7" width="1" height="1" fill="#000" fill-opacity="0.5"/>
    <rect x="4" y="6" width="1" height="1" fill="#000" fill-opacity="0.5"/>
    <rect x="1" y="5" width="1" height="1" fill="#000" fill-opacity="0.45"/>
  `),
});

registerSprite("cargo_pod_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="1" y="1" width="6" height="6" fill="${C.rim}"/>
    <rect x="2" y="2" width="4" height="4" fill="${C.brass}"/>
    <rect x="3" y="3" width="2" height="2" fill="${C.hull}"/>
  `),
});

registerSprite("life_support_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="1" y="1" width="6" height="6" fill="${C.rim}"/>
    <rect x="2" y="2" width="4" height="1" fill="${C.olive}"/>
    <rect x="2" y="5" width="4" height="1" fill="${C.cockHi}"/>
    <rect x="3" y="3" width="2" height="2" fill="${C.trim}"/>
  `),
});

registerSprite("antenna_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.panel}"/>
    <rect x="1" y="6" width="6" height="1" fill="${C.rim}"/>
    <rect x="3" y="2" width="2" height="4" fill="${C.hullHi}"/>
    <rect x="2" y="1" width="4" height="1" fill="${C.trim}"/>
    <rect x="1" y="0" width="6" height="1" fill="${C.trimHi}"/>
    <rect x="3" y="3" width="2" height="1" fill="${C.cockHi}"/>
  `),
});

registerSprite("crew_quarters_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="1" y="1" width="6" height="6" fill="${C.rim}"/>
    <rect x="2" y="2" width="2" height="2" fill="${C.cockpit}"/>
    <rect x="4" y="2" width="2" height="2" fill="${C.cockpit}"/>
    <rect x="2" y="4" width="2" height="2" fill="${C.cockpit}"/>
    <rect x="4" y="4" width="2" height="2" fill="${C.cockpit}"/>
    <rect x="3" y="3" width="1" height="1" fill="${C.trimHi}"/>
    <rect x="5" y="3" width="1" height="1" fill="${C.trimHi}"/>
    <rect x="3" y="5" width="1" height="1" fill="${C.trimHi}"/>
    <rect x="5" y="5" width="1" height="1" fill="${C.trimHi}"/>
  `),
});

registerSprite("docking_collar_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="1" y="1" width="6" height="6" fill="${C.rim}"/>
    <rect x="2" y="2" width="4" height="4" fill="${C.panel}"/>
    <rect x="3" y="3" width="2" height="2" fill="${C.trim}"/>
    <rect x="0" y="3" width="1" height="2" fill="${C.carbon}"/>
    <rect x="7" y="3" width="1" height="2" fill="${C.carbon}"/>
    <rect x="3" y="0" width="2" height="1" fill="${C.carbon}"/>
    <rect x="3" y="7" width="2" height="1" fill="${C.carbon}"/>
  `),
});

registerSprite("dock_light_trade", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect x="0" y="3" width="1" height="2" fill="#48c267"/>
    <rect x="7" y="3" width="1" height="2" fill="#48c267"/>
    <rect x="3" y="0" width="2" height="1" fill="#48c267"/>
    <rect x="3" y="7" width="2" height="1" fill="#48c267"/>
  `),
});

registerSprite("dock_light_board", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect x="0" y="3" width="1" height="2" fill="#e69234"/>
    <rect x="7" y="3" width="1" height="2" fill="#e69234"/>
    <rect x="3" y="0" width="2" height="1" fill="#e69234"/>
    <rect x="3" y="7" width="2" height="1" fill="#e69234"/>
  `),
});

registerSprite("conduit_universal", {
  width: 8, height: 8,
  svg: svg(8, 8, `<rect width="8" height="8" fill="#3a3a40" fill-opacity="0.95"/>`),
});

registerSprite("conduit_heat", {
  width: 8, height: 8,
  svg: svg(8, 8, `<rect width="8" height="8" fill="#e88080" fill-opacity="0.95"/>`),
});
registerSprite("conduit_heat_arrow", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect x="2" y="3" width="3" height="2" fill="#2a1010" fill-opacity="0.95"/>
    <rect x="4" y="2" width="1" height="4" fill="#2a1010" fill-opacity="0.95"/>
    <rect x="5" y="3" width="1" height="2" fill="#2a1010" fill-opacity="0.95"/>
  `),
});

registerSprite("collector_mk1", {
  width: 8, height: 8,
  svg: svg(8, 8, `
    <rect width="8" height="8" fill="${C.hull}"/>
    <rect x="1" y="1" width="6" height="1" fill="${C.rim}"/>
    <rect x="0" y="2" width="8" height="1" fill="${C.trim}"/>
    <rect x="1" y="3" width="6" height="1" fill="${C.carbon}"/>
    <rect x="2" y="4" width="4" height="1" fill="${C.carbon}"/>
    <rect x="3" y="5" width="2" height="2" fill="${C.brass}"/>
  `),
});